import styled from '@emotion/styled'
import { Box, Stack } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { Card } from 'components'

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const MainContentWrapper = styled(Box)`
  width: 100%;
  height: 78%;
  display: flex;
  gap: 10px;
  border-radius: '15px';
`

export const ColumnsBox = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: '15px';
`

export const SideContent = styled(Card)`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  border-radius: 15px;
`

export const ContentHeader = styled('div')`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0px 20px;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 2vh;
  border-radius: 15px;
  /* TODO: from theme */
  color: #4f4848;
  box-shadow:
    0px 0px 8px rgba(0, 0, 0, 0.04),
    0px 4px 16px rgba(238, 237, 237, 0.04);
`

export const ContentHeaderItem = styled('div')`
  flex: 1;
  padding: 0px 15px;
`

export const ListItem = styled('div')<{ active: boolean }>`
  flex: 1;
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  font-weight: 600;
  font-size: 15px;
  /* TODO: from theme */
  color: #4f4848;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
  pointer-events: ${({ active }) => active && 'none'};
  background-color: ${({ active }) => active && '#d9d9d930'};
  cursor: pointer;

  &:hover {
    background-color: #d9d9d930;
  }
`

export const Content = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding: 0px 10px;
  height: 80%;
`

export const Info = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  padding: 5px 20px;
  height: inherit;
  overflow-y: auto;
`

export const InfoItem = styled('div')`
  width: 100%;
  height: 76px;
  display: flex;
  justify-content: space-between;
  align-items: top;
  padding: 10px 10px 0 10px;
  background-color: #f9f9f9;
  font-weight: 600;
  color: #4f4848;
  border-radius: 6px;
  cursor: pointer;
`

export const Silos = styled('div')`
  display: flex;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  padding-left: 15px;
  padding-bottom: 10px;
`

export const MainContent = styled(Card)`
  flex: 3;
  height: 100%;
`
export const MainGrid = styled(Grid)`
  height: 100%;
  background-color: white;
  border-radius: 15px;
`

export const CardGrid = styled(Grid)`
  width: 100%;
  height: 10%;
  position: fixed;
  bottom: 0;
  z-index: 1000;
`

export const IconContainer = styled('div')<{ color }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${({ color }) => color};
  svg {
    fill: ${({ color }) => color};
  }
`

export const StackComponent = styled(Stack)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.5%;
  margin-right: 20px;
  margin-left: 20px;
`
